import { Component } from '@angular/core';

@Component({
  selector: 'black-pending-consent',
  templateUrl: './pending-consent.component.html',
  standalone: false,
})
export class PendingConsentComponent {}
